<template>
  <div class="dispatch-table">
    <div class="dispatch-table__header">
      <div :class="['header-item', item.width ? '' : 'flex']" v-for="(item, index) in columnData" :key="index"
           :style="{width: (item.width ? item.width : '0') + 'px'}">
        {{ item.label ? item.label : '' }}
      </div>
    </div>
    <el-scrollbar style="flex: 1;height: 0;">
      <div class="dispatch-table__content">
        <div class="content-item" v-for="(item,index) in tableData" :key="index">
          <div :class="['content-item__column', v.width ? '' : 'flex']" v-for="(v, vIndex) in columnData" :key="vIndex" :style="{width: (v.width ? v.width : '0') + 'px'}">
            <div class="column-item" v-if="v.prop === 'index'">{{index + 1}}</div>
            <div class="column-item" v-else>{{item[v.prop]}}</div>
          </div>
        </div>
      </div>
      <el-empty description="暂无数据" :image-size="64" :image="imageSrc" v-if="tableData.length === 0" ></el-empty>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: "dispatchTable",
  props: {
    columnData: {
      type: Array,
      default: () => []
    },
    tableData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      imageSrc: require('@/common/assets/images/empty.svg')
    }
  }
}
</script>

<style lang="scss" scoped>
.dispatch-table {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: #FFFFFF;

  &__header {
    height: 36px;
    background: linear-gradient(360deg, #1C3B68 0%, rgba(47, 61, 82, 0.0885) 100%);
    display: flex;

    .header-item {
      display: flex;
      align-items: center;
      justify-content: center;

      &.flex {
        flex: 1;
      }
    }
  }

  &__content {
    display: flex;
    flex-direction: column;

    .content-item {
      display: flex;
      border-bottom: 1px solid #1C3354;

      &__column {
        display: flex;
        padding: 12px 0;

        &.flex {
          flex: 1;
        }
        .column-item {
          width: 100%;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          word-break: break-all;
          line-height: 23px;
          padding-left: 10px;
          padding-right: 10px;
        }

      }
    }

  }
}
</style>
